module.exports = __webpack_public_path__ + "img/unnamed3.8bde9791.png";